var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"linear-gradient(90deg, rgba(38,50,56,1) 0%, rgba(69,90,100,1) 35%, rgba(38,50,56,1) 100%)","filter":"progid:DXImageTransform.Microsoft.gradient(startColorstr='#263238',endColorstr='#263238',GradientType=1)"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }